import { Component, OnInit } from '@angular/core';  
import { LoadingService } from '../_services/loading.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { LoggerService } from '../_services/logger.service';
import { JsonService } from '../_services/json.service';
import { AuthenticationService } from '../_services/authentication.service';
import { DialogService } from '../dialog/dialog.service';
import { jwtDecode } from 'jwt-decode';
import { IndexedDbService } from '../_services/indexed-db.service';

@Component({
  selector: 'app-auth-calback',
  templateUrl: './auth-calback.component.html',
  styleUrl: './auth-calback.component.scss'
})
export class AuthCalbackComponent implements OnInit {

  constructor(
    private loadingService: LoadingService,
    private router: Router,
    private route: ActivatedRoute,
    private jsonService: JsonService,
    private authService: AuthenticationService,
    private logger: LoggerService,
    private db: IndexedDbService,
    private dialogService: DialogService
  ) { }

  async ngOnInit(): Promise<void> {
    this.loadingService.show();

    const code = this.route.snapshot.queryParamMap.get('code');
    //const code_verifier = sessionStorage.getItem('code_verifier');
    const code_verifier = await this.db.getData('code_verifier');

    if (!code) {
      console.warn('Código não encontrado nos parâmetros da URL.');
      this.router.navigate(['/login']);
      return;
    }

    const returnedState = this.route.snapshot.queryParamMap.get('state');
    const expectedState = sessionStorage.getItem('oauth_state');
    if (!returnedState || returnedState !== expectedState) {
      console.error('State inválido — possível ataque CSRF no redirect OAuth.');
      this.router.navigateByUrl('/login');
      return;
    }
    sessionStorage.removeItem('oauth_state');
    sessionStorage.removeItem('oauth_nonce');

    sessionStorage.setItem('code_get', code);

    if (!code_verifier) {
      console.warn('Code Verifier não encontrado no sessionStorage.');
      //this.router.navigate(['/login']);
      this.router.navigateByUrl('/login');
      return;
    }

    this.authService.exchangeToken(code, code_verifier).subscribe({
      next: (res: any) => {
        this.db.saveData('id_token', res.id_token);
        this.db.saveData('access_token', res.access_token);
        this.db.saveData('refresh_token', res.refresh_token);

        const decodedToken: any = jwtDecode(res.id_token);
        sessionStorage.setItem('username', decodedToken?.username);

        this.router.navigate(['/']);
      },
      error: err => {
        console.error('Erro no token exchange', err);
        //this.router.navigate(['/login']);
        this.router.navigateByUrl('/login');
      }
    });
  }

}
